export default __webpack_public_path__ + "static/media/app_mytoyota.990c7652.png";